/** @module Apparel/PrintDesign/PrintTechniquesMatrix */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/locale",
	"csi/table/matrix/Index",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/Writer"
], function(declare, _, locale, Index, xml, Query, Writer) {

	return declare(Index, {

		/** @property {Boolean} - flag for deciding if custom report query is required for fetching count */
		queryForPrintTechniquesCount: false,

		/** @property {integer} prTechCt - PrintTechniquesCount to display number of Print Techniques heading */
		prTechCt: null,

		/**
		 * Add deferreds to fetch max PrintTechniquesCount value from PrintDesignRevision Node using CustomReport
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @param {Deferred[]} dfds
		 */
		addDeferred: function(ctx, h, dfds) {
			const id = "PrintTechniquesCount";

			if (this.queryForPrintTechniquesCount) {
				const q = new Query();
				q.Type("PrintDesignRevision");
				const queryString = q.toString();

				const expressionValue = "maxQuery(null,__Query__,null," + "\"" + id + "\"" + ")";
				const w = new Writer().setReport();

				w.createNode(null, "CustomReport")
					.publishAttribute("__Query__", xml.ATTR_STRING, queryString)
					.publishAttribute(id, null, null, null, null, null, expressionValue);

				dfds.push(w.execute().then(response => {
					const customReportNodes = response.getNodes();
					this.prTechCt = customReportNodes[0][id];
				}));
			} else {
				const printDesignRevisionNode = ctx.getNode();
				this.prTechCt = printDesignRevisionNode[id];
			}
		},

		/**
		 * @override
		 * Return label for heading at given index
		 */
		_label(ctx, h, index) {
			return locale.resource("PrintTechniqueIndex", [index + 1]);
		},

		/**
		 * @override
		 * Return number of print techniques to render
		 */
		_size(ctx, h) {
			return this.prTechCt;
		},
	});
});